// extracted by mini-css-extract-plugin
export default {"zoomControls":"ZoomControls_zoomControls__YuWh1","toolButton":"ZoomControls_toolButton__0JAMV","active":"ZoomControls_active__LppJI","zoomLevel":"ZoomControls_zoomLevel__cK0+m"};